module.exports = __webpack_public_path__ + "static/media/GazhLogo_w.087fcdbd.png";